import r from '../Utils/fetch';

const w: any = window;
const API_URL = w.API_MCP_PUBLIC_URL;

// =============================================================================
// TYPES
// =============================================================================

export interface AnalyzeRequest {
	processId: string;
	objective?: string;
}

export interface DatasetStats {
	totalRows: number;
	tableCount: number;
	columnCount: number;
}

export interface AnalysisMetadata {
	model: string;
	tokensUsed: number;
	testDataset: string;
	prodDataset: string;
	tablesCompared: string[];
	testStats: DatasetStats;
	prodStats: DatasetStats;
	duration: number; // nanoseconds
}

export interface AnalyzeResponse {
	analysis: string;
	metadata: AnalysisMetadata;
}

// =============================================================================
// API
// =============================================================================

export const analyzeTestVsProd = (request: AnalyzeRequest): Promise<AnalyzeResponse> =>
	r({
		url: `${API_URL}/admin/data-comparison/analyze`,
		method: 'POST',
		data: request,
	});
